import { Link } from 'react-router-dom';
import ScrollAnimation from '../../../components/base/ScrollAnimation';

export default function ServicesSection() {
  const services = [
    {
      title: 'Window Tinting',
      description: 'Premium ceramic and standard tint options for all vehicles. Superior heat rejection and UV protection with a sleek, professional finish.',
      icon: 'ri-car-line',
      image: 'https://img1.wsimg.com/isteam/ip/abffa065-2f17-4bc9-b67a-6803e73e4f84/01-f2adb302.png',
      link: '/window-tinting',
      features: ['Ceramic Tint', 'Standard Tint', 'Lifetime Warranty', 'Expert Install'],
    },
    {
      title: 'Mobile Window Tinting',
      description: 'We come to you! Professional tinting service at your home or office. Convenient, fast, and hassle-free installation wherever you are.',
      icon: 'ri-home-4-line',
      image: 'https://public.readdy.ai/ai/img_res/82f50aa83d840e868d3b0d44bcb9479f.jpg',
      link: '/mobile-tinting',
      features: ['At Your Location', 'Same Day Service', 'No Shop Visit', 'Full Equipment'],
    },
    {
      title: 'Headlight & Taillight Tinting',
      description: 'Transform your vehicle\'s appearance with professional light tinting. Add style and protection while maintaining safety and legal compliance.',
      icon: 'ri-lightbulb-flash-line',
      image: 'https://readdy.ai/api/search-image?query=professional-tinted-car-headlights-close-up-smoke-film-on-modern-LED-headlamps-sleek-automotive-styling-premium-quality-finish-dark-translucent-appearance-clean-studio-photography-luxury-vehicle-detail&width=600&height=400&seq=headlight-service-1&orientation=landscape',
      link: '/headlight-taillight-tinting',
      features: ['Smoke Tint', 'Dark Smoke', 'Legal Compliant', 'Professional Install'],
    },
    {
      title: 'Vehicle Decals',
      description: 'Custom vinyl graphics and decals for personal or business branding. High-quality materials with professional installation and design.',
      icon: 'ri-palette-line',
      image: 'https://readdy.ai/api/search-image?query=custom-vehicle-vinyl-decals-and-graphics-on-modern-car-professional-automotive-wrap-installation-sleek-design-business-branding-high-quality-finish-clean-studio-lighting&width=600&height=400&seq=decals1&orientation=landscape',
      link: '/vehicle-decals',
      features: ['Custom Design', 'Business Logos', 'Vinyl Graphics', 'Professional Install'],
    },
  ];

  return (
    <section className="py-24 max-md:py-8 bg-gradient-to-b from-white to-gray-50 mobile-compact-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollAnimation animation="fade-in">
          <div className="text-center mb-16 max-md:mb-6 mobile-compact-spacing">
            <h2 className="text-4xl md:text-5xl max-md:text-2xl font-bold text-secondary mb-4 max-md:mb-2">
              Our Premium Services
            </h2>
            <p className="text-xl max-md:text-sm text-gray-600 max-w-3xl mx-auto mobile-compact-text">
              Professional window tinting solutions tailored to your needs. Quality materials, expert installation, and unbeatable customer service.
            </p>
          </div>
        </ScrollAnimation>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-md:gap-4 mobile-compact-gap">
          {services.map((service, index) => (
            <ScrollAnimation
              key={service.title}
              animation={index % 2 === 0 ? 'slide-in-left' : 'slide-in-right'}
              delay={index * 100}
            >
              <Link to={service.link} className="group block">
                <div className="bg-white rounded-2xl max-md:rounded-lg shadow-lg overflow-hidden transition-all duration-300 hover:shadow-2xl hover:-translate-y-2 h-full">
                  {/* Image */}
                  <div className="relative h-64 max-md:h-32 overflow-hidden">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                    <div className="absolute bottom-4 max-md:bottom-2 left-4 max-md:left-2 flex items-center space-x-3 max-md:space-x-2">
                      <div className="w-12 h-12 max-md:w-8 max-md:h-8 bg-primary rounded-full flex items-center justify-center">
                        <i className={`${service.icon} text-white text-2xl max-md:text-lg`}></i>
                      </div>
                      <h3 className="text-2xl max-md:text-base font-bold text-white">{service.title}</h3>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-6 max-md:p-3">
                    <p className="text-gray-600 max-md:text-xs mb-4 max-md:mb-2 leading-relaxed mobile-compact-text">{service.description}</p>
                    
                    {/* Features */}
                    <div className="grid grid-cols-2 gap-2 max-md:gap-1 mb-4 max-md:mb-2">
                      {service.features.map((feature) => (
                        <div key={feature} className="flex items-center space-x-2 max-md:space-x-1">
                          <i className="ri-check-line text-primary w-4 h-4 max-md:w-3 max-md:h-3 flex items-center justify-center max-md:text-xs"></i>
                          <span className="text-sm max-md:text-xs text-gray-700 whitespace-nowrap">{feature}</span>
                        </div>
                      ))}
                    </div>

                    {/* CTA */}
                    <div className="flex items-center text-primary font-semibold group-hover:text-accent transition-colors max-md:text-sm">
                      <span className="whitespace-nowrap">Learn More</span>
                      <i className="ri-arrow-right-line ml-2 transition-transform group-hover:translate-x-2 w-5 h-5 max-md:w-4 max-md:h-4 flex items-center justify-center"></i>
                    </div>
                  </div>
                </div>
              </Link>
            </ScrollAnimation>
          ))}
        </div>
      </div>
    </section>
  );
}
